import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { WebSocketService } from './websocket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DebugComponent implements OnInit, OnDestroy {
  message: string;
  subscriptions: Subscription = new Subscription();

  constructor(public wsService: WebSocketService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.wsService.greeting.subscribe((greeting) => {
        this.message = greeting ? greeting.content : '';
      }),
    );
    this.wsService.connect();
  }

  ngOnDestroy(): void {
    this.wsService.disconnect();
    this.subscriptions.unsubscribe();
  }

  send() {
    this.wsService.send({ name: 'Foo' });
  }
}
